<form [formGroup]="preparationForm">
    <!-- Fila 1: Estado + Ubicación (col-6 fijo) -->
    <div class="row d-flex align-items-end">
      <div class="col-6 mb-3">
          <label for="delivery_status" class="form-label">{{
            "inputs.delivery_status" | translate
            }}</label>
          <ng-select formControlName="delivery_status" [items]="delivery_status" bindValue="key" bindLabel="name"
            [placeholder]="'inputs.delivery_status' | translate" [searchable]="true" [clearable]="false"
            [notFoundText]="'tables.no_results' | translate">
          </ng-select>
      </div>
      <div class="col-6 mb-3">
          <label for="delivery_current_location" class="form-label">{{
            "inputs.delivery_current_location" | translate
            }}</label>
          <div class="input-group div-copy">
            <input type="text" class="form-control" id="delivery_current_location" required
              formControlName="delivery_current_location" placeholder="{{
                  'inputs.delivery_current_location' | translate
                }}" #inputFieldDeliveryCurrentLocation />
            <div class="input-group-append">
              <button class="btn btn-outline-secondary copy" type="button"
                (click)="copyToClipboard(inputFieldDeliveryCurrentLocation.value,$event)">
                <i class="icon-copy"></i>
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="row linea"></div>
    <!-- Fila 2: Fecha fabricación esperada + real (col-6 fijo) -->
    <div class="row d-flex align-items-end">
      <div class="col-6 mb-3">
          <label for="manufacture_expected_date" class="form-label">{{
            "inputs.manufacture_expected_date" | translate
            }}</label>
          <span class="info-icon" tabindex="0">
            <i class="icon-notification"></i>
            <span class="tooltip">{{
              'inputs.i.manufacture_expected_date' | translate
              }}</span>
          </span>
          <div class="input-group">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="manufacture_expected_date" formControlName="manufacture_expected_date"
                placeholder="{{
                        'inputs.manufacture_expected_date' | translate
                      }}" />
              <mat-datepicker-toggle matSuffix [for]="manufacture_expected_date"></mat-datepicker-toggle>
              <mat-datepicker #manufacture_expected_date></mat-datepicker>
            </mat-form-field>
          </div>
      </div>

      <div class="col-6 mb-3">
          <label for="vehicle_manufacturing_date" class="form-label">{{
            "inputs.vehicle_manufacturing_date"
            | translate
            }}<span class="required">*</span></label>
          <span class="info-icon" tabindex="0">
            <i class="icon-notification"></i>
            <span class="tooltip">{{
              'inputs.i.vehicle_manufacturing_date' | translate
              }}</span>
          </span>
          <div class="input-group">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="vehicle_manufacturing_date" formControlName="vehicle_manufacturing_date"
                placeholder="{{
                      'inputs.vehicle_manufacturing_date' | translate
                    }}" />
              <mat-datepicker-toggle matSuffix [for]="vehicle_manufacturing_date"></mat-datepicker-toggle>
              <mat-datepicker #vehicle_manufacturing_date></mat-datepicker>
            </mat-form-field>
          </div>
      </div>
    </div>
  <div class="row linea"></div>
    <!-- Taller/Campa: col-12 mobile, col-6 desktop -->
    <div class="row">
      <div class="col-12 col-xl-6 mb-3">
          <label for="workshop" class="form-label">{{
            "inputs.workshop" | translate
            }}</label>
          <ng-select formControlName="workshop_id" [items]="workshopData" bindValue="reference" bindLabel="name"
            [placeholder]="'inputs.workshop' | translate" [searchable]="true" [clearable]="false"
            [notFoundText]="'tables.no_results' | translate">
          </ng-select>
      </div>
    </div>
     <!-- Fecha inicio + fin preparación: col-6 fijo -->
     <div class="row">
         <div class="col-6 mb-3">
          <label for="preparation_start_date" class="form-label">{{
            "inputs.preparation_start_date"
            | translate
            }}<span class="required">*</span></label>

          <span class="info-icon" tabindex="0">
            <i class="icon-notification"></i>
            <span class="tooltip">{{
              'inputs.i.preparation_start_date' | translate
              }}</span>
          </span>
          <div class="input-group">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="preparation_start_date"
                formControlName="preparation_start_date" placeholder="{{
                    'inputs.preparation_start_date' | translate
                  }}" />
              <mat-datepicker-toggle matSuffix [for]="preparation_start_date"></mat-datepicker-toggle>
              <mat-datepicker #preparation_start_date></mat-datepicker>
            </mat-form-field>
          </div>
      </div>
        <div class="col-6 mb-3">
          <label for="preparation_end_date" class="form-label">{{
            "inputs.preparation_end_date"
            | translate
            }}<span class="required">*</span></label>

          <span class="info-icon" tabindex="0">
            <i class="icon-notification"></i>
            <span class="tooltip">{{
              'inputs.i.preparation_end_date' | translate
              }}</span>
          </span>
          <div class="input-group">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="preparation_end_date"
                formControlName="preparation_end_date" placeholder="{{
                    'inputs.preparation_end_date' | translate
                  }}" />
              <mat-datepicker-toggle matSuffix [for]="preparation_end_date"></mat-datepicker-toggle>
              <mat-datepicker #preparation_end_date></mat-datepicker>
            </mat-form-field>
          </div>
      </div>
    </div>


    <div class="row">
      <div class="mb-3">
        <label for="preparation_notes" class="form-label">{{
          "inputs.preparation_notes" | translate
          }}</label>
        <div class="input-group">
          <textarea class="form-control textarea100" id="preparation_notes" rows="2" required
            formControlName="preparation_notes"></textarea>
        </div>
      </div>
    </div>
<div class="row linea"></div>
    <!-- Fecha documento: col-12 mobile, col-6 desktop -->
    <div class="row">
         <div class="col-12 col-xl-6 mb-3">
          <label for="vehicle_preparation_document_date" class="form-label">{{
            "inputs.vehicle_preparation_document_date"
            | translate
            }}<span class="required">*</span></label>

          <span class="info-icon" tabindex="0">
            <i class="icon-notification"></i>
            <span class="tooltip">{{
              'inputs.i.vehicle_preparation_document_date' | translate
              }}</span>
          </span>
          <div class="input-group">
            <mat-form-field appearance="fill">
              <input matInput [matDatepicker]="vehicle_preparation_document_date"
                formControlName="vehicle_preparation_document_date" placeholder="{{
                    'inputs.vehicle_preparation_document_date' | translate
                  }}" />
              <mat-datepicker-toggle matSuffix [for]="vehicle_preparation_document_date"></mat-datepicker-toggle>
              <mat-datepicker #vehicle_preparation_document_date></mat-datepicker>
            </mat-form-field>
          </div>
      </div>
    </div>
  </form>
